import { useFeatureFlag } from 'mf_core/feature-flag';

export function useFeatureFlagBase() {
  const {
    isReady,
    refetch,
    value: boValues,
  } = useFeatureFlag([
    'ACC_MGMT_EPP_WhitelistedResellers',
    'ACC_MGMT_EnableX4CReactUI',
    'ACC_MGMT_EnableX4CReactUI',
    'ACC_MGMT_Enable_BrandingPreferences',
    'CCAI_Chatbot_WhitelistedResellers',
    'CCAI_Paths_Whitelist',
    'CCAI_Translation_Keys',
    'CCAI_UNITE_Disabled',
    'CCAI_UNITE_Translation_Keys',
    'CMP_CreditCardPopup_Enable',
    'CMP_CreditCardTermCode',
    'CMP_Products_ExcludedResellers',
    'DisableCartIconOnAddToCart',
    'Docdata_DD_CMP_TermCode',
    'EnableInsightsMessagingQueue',
    'EnableInsightsFrameWork',
    'EnableUserManagement',
    'Enable_AISuggestions',
    'Enable_Order_Status_Report',
    'FORSTA_Feedback_Form_WhitelistedResellers',
    'FORSTA_Feedback_Form_WhitelistedResellers',
    'Is_Cybersource_Force_Popup_Enabled',
    'Is_DocData_DD_enabled',
    'Is_Docdata_MP_PopUp_Enabled',
    'Is_Worldpay_MP_PopUp_Enabled',
    'Is_Worldpay_enabled',
    'QM_EnableSearch_BO',
    'Reseller_Whitelist_For_Order_Status_Tracking',
    'Worldpay_CMP_TermCode',
    'X4C_Enable_Performance_Banner',
    'X4C_Performance_Banner_End_Time',
    'X4C_Performance_Banner_Start_Time',
    'X4C_PushNotifications_Enabled',
    'X4C_Url_Encoding_Feature',
    'X4EUEnabled',
    'EnableQuickInsightsRollDown',
    'im-customerintegrations-appstore-home-showintegrationshub',
  ]);
  return {
    boValues,
    isReady,
    refetch,
  };
}
